import { render } from "./XypService.vue?vue&type=template&id=2e32d042&scoped=true&ts=true"
import script from "./XypService.vue?vue&type=script&lang=ts"
export * from "./XypService.vue?vue&type=script&lang=ts"

import "./XypService.vue?vue&type=style&index=0&id=2e32d042&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e32d042"]])

export default __exports__